import { render } from "./groupAdd.vue?vue&type=template&id=23e3a57a&scoped=true"
import script from "./groupAdd.vue?vue&type=script&lang=js"
export * from "./groupAdd.vue?vue&type=script&lang=js"

import "./groupAdd.vue?vue&type=style&index=0&id=23e3a57a&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e3a57a"]])

export default __exports__